var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.selectedStore
      ? _c(
          "button",
          {
            staticClass: "button",
            class: { "set-width": !_vm.selectedStore },
            attrs: { type: "button large", "data-open": "locatorModal" }
          },
          [_vm._v("\n        Select a Store\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.selectedStore ? _c("hr", { staticClass: "b-margin" }) : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button",
        class: { "set-width": !_vm.selectedStore },
        attrs: { type: "button large", "data-open": "scheduleModal" }
      },
      [_vm._v("\n        Request an Appointment\n    ")]
    ),
    _vm._v(" "),
    _vm.selectedStore ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _vm.selectedStore
      ? _c("p", { staticClass: "text-center call-text-p" }, [
          _c("strong", [_vm._v("Have Questions?")]),
          _vm._v(" Call: "),
          _c("span", [
            _c("a", { attrs: { href: "tel:" + _vm.phone } }, [
              _vm._v(_vm._s(_vm.phone))
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }